/* eslint-disable import/order */
import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import signupLogo from 'assets/images/signup-logo.webp';
import qr from 'assets/images/qr-evie-download.webp';

import { ROUTES } from 'utils/constants';
import { useLocalStorage } from 'utils/hooks/useLocalStorage';
import SolidButton from 'components/SolidButton';
import { useGetParams } from '../utils/useGetParams';
import { KEYS } from '../utils/constants';

const ThankyouScreen = ({ background }) => {
  const { t } = useTranslation();
  const { push } = useGetParams();
  const [flow] = useLocalStorage(KEYS.FLOW);

  const handleBackToAssistant = () => {
    push(ROUTES.EVIE_ASSISTANT);
  };

  return (
    <section className={`info-screen quiz-starter thankyou-screen ${background}`}>
      <div>
        <img className="thankyou-screen_logo" src={signupLogo} alt="Evie logo" />
        <h2 className="thankyou-screen_title">{t('evieOnboarding.thankyouScreen.title')}</h2>
        <p className="thankyou-screen_content">{t('evieOnboarding.thankyouScreen.content')}</p>
        <li className="thankyou-screen__steps">
          <ol>{t('evieOnboarding.thankyouScreen.steps.one')}</ol>
          <ol>{t('evieOnboarding.thankyouScreen.steps.two')}</ol>
        </li>
        <a
          className="thankyou-screen__steps_link"
          href="https://hievie.onelink.me/g6dj/uzk92mo5"
          target="_blank"
          rel="noreferrer"
        >
          {t('evieOnboarding.thankyouScreen.btn')}
        </a>
        {flow === 'assistant' && (
          <SolidButton className="evie-secondary thankyou-screen_assistant-btn" onClick={handleBackToAssistant}>
            {t('evieOnboarding.thankyouScreen.backToAssistantBtn')}
          </SolidButton>
        )}
        <p className="thankyou-screen_content">{t('evieOnboarding.thankyouScreen.steps.qr')}</p>
        <img src={qr} alt="QR to download Evie app" className="thankyou-screen_qr" />
      </div>
    </section>
  );
};

ThankyouScreen.propTypes = {
  background: PropTypes.string.isRequired,
};

export default ThankyouScreen;
